import { render } from "./DisplayPanel.vue?vue&type=template&id=0a6feac2&scoped=true"
import script from "./DisplayPanel.vue?vue&type=script&lang=js"
export * from "./DisplayPanel.vue?vue&type=script&lang=js"

import "./DisplayPanel.vue?vue&type=style&index=0&id=0a6feac2&scoped=true&lang=css"

import exportComponent from "/home/ec2-user/c2stem-server/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a6feac2"]])

export default __exports__